import script from "./open-ended-text.vue?vue&type=script&setup=true&lang=js"
export * from "./open-ended-text.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__